import styled from 'styled-components';

import { Box } from 'components/Box';
import { cssBreakpoints, gutterWidth, maxWidth } from 'theme/theme';

export const Grid = styled(Box)`
  margin: 0 auto;

  @supports (grid-column-gap: ${gutterWidth}px) {
    padding: 0 ${gutterWidth / 2}px;
  }

  @media all and (min-width: ${cssBreakpoints.mdUp}) {
    display: grid;
    grid-template-columns: repeat(
      auto-fill,
      ${maxWidth[2] / 12 - gutterWidth}px
    );
    max-width: ${maxWidth[2]}px;

    @supports (grid-column-gap: ${gutterWidth}px) {
      grid-column-gap: ${gutterWidth}px;
    }
  }

  @media all and (min-width: ${cssBreakpoints.lgUp}) {
    grid-template-columns: repeat(
      auto-fill,
      ${(maxWidth[3] - gutterWidth) / 12 - gutterWidth}px
    );
    max-width: ${maxWidth[3]}px;

    @supports (grid-column-gap: ${gutterWidth}px) {
      padding: 0 ${gutterWidth}px;
    }
  }
`;
